export const RegistrationType = {
  ADOPTEE: { value: "ADOPTEE", label: "Adult adoptee" },
  BIRTH_PARENT: { value: "BIRTH_PARENT", label: "Birth parent" },
  SIBLING: { value: "SIBLING", label: "Sibling with a common birth parent" },
};

export const RegistrationTypes = [RegistrationType.ADOPTEE, RegistrationType.BIRTH_PARENT, RegistrationType.SIBLING];

export const BirthSexOption = {
  FEMALE: { value: "F", label: "Female" },
  MALE: { value: "M", label: "Male" },
  UNKNOWN: { value: "U", label: "Unknown / Neither Female nor Male" },
};

export const BirthSexOptions = [BirthSexOption.FEMALE, BirthSexOption.MALE, BirthSexOption.UNKNOWN];

export const IdentificationStatus = {
  NO_SUBMISSION: { value: "NO_SUBMISSION", label: "No Submission" },
  PENDING_REVIEW_MAIL: { value: "PENDING_REVIEW_MAIL", label: "ID Mailed - Pending Review" },
  PENDING_REVIEW_UPLOAD: { value: "PENDING_REVIEW_UPLOAD", label: "ID Uploaded - Pending Review" },
  VERIFIED: { value: "VERIFIED", label: "Verified" },
};

export const IdentificationStatusOptions = [
  IdentificationStatus.NO_SUBMISSION,
  IdentificationStatus.PENDING_REVIEW_MAIL,
  IdentificationStatus.PENDING_REVIEW_UPLOAD,
  IdentificationStatus.VERIFIED,
];

export const RegistrationStatus = {
  REGISTERED: { value: "REGISTERED", label: "Newly Registered" },
  SEARCHED_NO_MATCH: { value: "SEARCHED_NO_MATCH", label: "Match not found" },
  NEEDS_RESEARCH: { value: "NEEDS_RESEARCH", label: "Needs search after update" },
  MATCHED: { value: "MATCHED", label: "Match found" },
};

export const RegistrationStatusOptions = [
  RegistrationStatus.REGISTERED,
  RegistrationStatus.SEARCHED_NO_MATCH,
  RegistrationStatus.NEEDS_RESEARCH,
  RegistrationStatus.MATCHED,
];

export const FeeStatus = {
  FEE_PENDING: { value: "FEE_PENDING", label: "Fee pending" },
  UPDATE_FEE_PENDING: { value: "UPDATE_FEE_PENDING", label: "Update fee pending" },
  PREV_PAID_PENDING: { value: "PREV_PAID_PENDING", label: "Previously paid, pending verification" },
  FEE_WAIVED: { value: "FEE_WAIVED", label: "Fee waived" },
  FEE_PAID: { value: "FEE_PAID", label: "Fee paid" },
};

export const FeeStatusOptions = [
  FeeStatus.FEE_PENDING,
  FeeStatus.UPDATE_FEE_PENDING,
  FeeStatus.PREV_PAID_PENDING,
  FeeStatus.FEE_WAIVED,
  FeeStatus.FEE_PAID,
];

export const MatchStatus = {
  MATCH_SUGGESTED: { value: "MATCH_SUGGESTED", label: "Match Suggested" },
  MATCH_REJECTED: { value: "MATCH_REJECTED", label: "Match Rejected" },
  MATCH_INPROCESS: { value: "MATCH_INPROCESS", label: "Match In Process" },
  MATCH_READY: { value: "MATCH_READY", label: "Match Ready to Notify User" },
  MATCH_COMPLETED: { value: "MATCH_COMPLETED", label: "Match Complete, Users notified" },
};

export const MatchStatusOptions = [
  MatchStatus.MATCH_SUGGESTED,
  MatchStatus.MATCH_REJECTED,
  MatchStatus.MATCH_INPROCESS,
  MatchStatus.MATCH_READY,
  MatchStatus.MATCH_COMPLETED,
];
